const fields = {
    "industry_bucket": null,
    "website": null, 
    "email": null
};
const calcFields = {
    "monthly_orders__c": null,
    "aov__c": null,
    "calculator_savings": null
};

window.addEventListener("DOMContentLoaded", () => {
    const leadForm = document.querySelector("#calcSection__leadForm");
    const calcForm = document.querySelector("#c-savings-calc-form");

    for (let calcField in calcFields) {
        if( calcField != "calculator_savings") {
            calcFields[calcField] = calcForm.querySelector(`input[name="${calcField}"]`);

            calcFields[calcField].addEventListener("input", (e) => {
                if(e.target.getAttribute("error")) {
                    if (e.target.validity.valid) {
                        e.target.removeAttribute("error");
                    }
                }
            });
        }
    }

    for (let field in fields) {
        fields[field] = leadForm.querySelector(`input[name="${field}"]`);

        if(!fields[field]) {
            fields[field] = leadForm.querySelector(`select[name="${field}"]`);
        }

        fields[field].addEventListener("input", (e) => {
            if(e.target.getAttribute("error")) {
                if (e.target.validity.valid) {
                    e.target.removeAttribute("error");
                }
            }
        });
    }

    leadForm.calcSection__leadFormIndustry.addEventListener("change", (e) => {
        e.target.setAttribute("isdefault", "false");
    });

    leadForm.addEventListener("submit", (e) => {
        e.preventDefault();
        let valid = true;

        for (let field in fields) {
            // let errSpan = fields[field].parentElement.querySelector('.c-demo-form__error');
            // let errMsg;
            if (!fields[field].validity.valid) {
                valid = false;

                // if(fields[field].validity.valueMissing) {
                //     errMsg = "Please enter a value";
                // } else if (fields[field].validity.typeMismatch) {
                //     errMsg = "Please enter a valid ";

                //     switch (field) {
                //         case "email":
                //             errMsg += "email";
                //             break;
                //         case "website":
                //             errMsg += "url (starting with https://)"
                //             break;
                //     }
                // }

                // errSpan.textContent = errMsg;
                fields[field].setAttribute("error", true);
            }
            // } else {
            //     errSpan.textContent = "";
            //     fields[field].removeAttribute("error");
            // }
        }

        for (let calcField in calcFields) {
            // let errSpan = fields[field].parentElement.querySelector('.c-demo-form__error');
            // let errMsg;
            if (calcField != "calculator_savings") {
                if (!calcFields[calcField].validity.valid) {
                    valid = false;

                    // if(calcFields[field].validity.valueMissing) {
                    //     errMsg = "Please enter a value";
                    // } else if (calcFields[field].validity.typeMismatch) {
                    //     errMsg = "Please enter a valid ";

                    //     switch (field) {
                    //         case "email":
                    //             errMsg += "email";
                    //             break;
                    //         case "website":
                    //             errMsg += "url (starting with https://)"
                    //             break;
                    //     }
                    // }

                    // errSpan.textContent = errMsg;
                    calcFields[calcField].setAttribute("error", true);
                }
            }
            // } else {
            //     errSpan.textContent = "";
            //     fields[field].removeAttribute("error");
            // }
        }

        if(!valid) {
            e.preventDefault();
            return;
        }

        let resp = sendRequestToHubSpot(leadForm, calcForm);

        resp.then(() => {
            document.querySelector(".c-savings-calc-output__number").setAttribute("blurred", "false");
        });
    });
});

async function sendRequestToHubSpot(leadForm, calcForm) {
    // Create the new request 
    let xhr = new XMLHttpRequest();
    let url = 'https://api.hsforms.com/submissions/v3/integration/submit/6898498/054f2574-f487-41bc-9da6-4e7e89dc8174';

    // Example request JSON:
    let data = {
        "fields": [
            {
            "objectTypeId": "0-1",
            "name": "utm_source",
            "value": leadForm.utm_source.value
            },
            {
            "objectTypeId": "0-1",
            "name": "utm_medium",
            "value": leadForm.utm_medium.value
            },
            {
            "objectTypeId": "0-1",
            "name": "utm_campaign",
            "value": leadForm.utm_campaign.value
            },
            {
            "objectTypeId": "0-1",
            "name": "utm_content",
            "value": leadForm.utm_content.value
            },
            {
            "objectTypeId": "0-1",
            "name": "utm_term",
            "value": leadForm.utm_term.value
            },
            {
            "objectTypeId": "0-1",
            "name": "last_offer",
            "value": leadForm.last_offer.value
            },
            {
            "objectTypeId": "0-1",
            "name": "first_page_seen__c",
            "value": leadForm.first_page_seen__c.value
            },
            {
            "objectTypeId": "0-1",
            "name": "conversion_page__c",
            "value": leadForm.conversion_page__c.value
            },
            {
            "objectTypeId": "0-1",
            "name": "gclid",
            "value": leadForm.gclid.value
            },
            {
            "objectTypeId": "0-1",
            "name": "msclkid",
            "value": leadForm.msclkid.value
            },
            {
            "objectTypeId": "0-1",
            "name": "fbclid",
            "value": leadForm.fbclid.value
            },
            {
            "objectTypeId": "0-1",
            "name": "salesforce_sync",
            "value": leadForm.salesforce_sync.value
            }
        ],
        "context": {
            "hutk": getCookie("hubspotutk"),
            "pageUri": pageInfo.pageUri,
            "pageName": pageInfo.pageName
        }
    }

    for (let calcField in calcFields) {
        if(calcField == "monthly_orders__c") {
            data.fields.push({
                "objectTypeId": "0-1",
                "name": calcField,
                "value": Math.round(calcFields[calcField].value / 12)
            });
        } else if (calcField == "aov__c") {
            data.fields.push({
                "objectTypeId": "0-1",
                "name": calcField,
                "value": calcFields[calcField].value
            });
        } else if (calcField == "calculator_savings") {
            data.fields.push({
                "objectTypeId": "0-1",
                "name": calcField,
                "value": parseInt(document.querySelector("#calculator_savings").getAttribute("savings"))
            });
        }
    }

    for (let field in fields) {
        data.fields.push({
            "objectTypeId": "0-1",
            "name": field,
            "value": fields[field].value
        });
    }

    let final_data = JSON.stringify(data);
    
    return makeRequest('POST', url, final_data);
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function makeRequest(method, url, data) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.send(data);
    });
}